import { useState, PropsWithChildren } from "react";
import { DialogResponsive } from "@/components/common/dialogs";
import { Rule } from "@/types";
import { FormCreateRule } from "./form-create-rule";
import { FormUpdateRule } from "./form-update-rule";

type FormRuleProps = PropsWithChildren & {
  rule?: Rule;
};

export function FormRule({ children, rule }: FormRuleProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={rule ? "Atualizar permissões" : "Novo permissões"}
      description={
        rule
          ? "Preencha os campos para atualizar o permissões."
          : "Preencha os campos para criar uma nova permissões."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
    >
      {rule ? (
        <FormUpdateRule rule={rule} handleClose={() => setOpen(false)} />
      ) : (
        <FormCreateRule handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
